import React, { useMemo } from 'react';

import '../../colors.css';
import './css/PolicyHeader.css';
import { getThemeLogoById } from '../../theme/theme.utils';

const PolicyHeader = ({ children, company, logoClass }) => {
  const getCompanyLogo = useMemo(() => {
    const logos = getThemeLogoById(company);
    return logos.white;
  }, [company]);

  return (
    <div className="Policy-header-container">
      <img
        alt=""
        className={`Policy-header-logo-${company} ${logoClass || ''}`}
        src={getCompanyLogo}
      />

      {children}
    </div>
  );
};

export { PolicyHeader };
